/** Composite each layer once so overlapping marks share the layer opacity. */
export function createMapLayerPainter() {
  const buffer = document.createElement("canvas");
  return (
    target: CanvasRenderingContext2D,
    opacity: number,
    paint: (context: CanvasRenderingContext2D) => void,
  ): void => {
    if (opacity >= 1) {
      paint(target);
      return;
    }
    if (opacity <= 0) return;
    if (
      buffer.width !== target.canvas.width ||
      buffer.height !== target.canvas.height
    ) {
      buffer.width = target.canvas.width;
      buffer.height = target.canvas.height;
    }
    const context = buffer.getContext("2d");
    if (context === null) return;
    context.resetTransform();
    context.clearRect(0, 0, buffer.width, buffer.height);
    context.save();
    context.setTransform(target.getTransform());
    paint(context);
    context.restore();
    target.save();
    target.resetTransform();
    target.globalAlpha = opacity;
    target.drawImage(buffer, 0, 0);
    target.restore();
  };
}
